import React from "react";
import * as Icons from "lucide-react";
import { PageHead, Loader } from "../components/PageHead";
import { useFetch } from "../lib/useApi";

export default function Reports() {
  const { data, loading } = useFetch("/reports");
  return (
    <>
      <PageHead crumb="Records" title="Reports" sub="Every operational report, filterable and exportable." />
      {loading ? <Loader /> : (
        <div className="grid cols-3" data-testid="reports-grid">
          {(data || []).map((r) => {
            const Icon = Icons[r.icon] || Icons.FileText;
            return (
              <div className="card report-card" key={r.key} data-testid={`report-${r.key}`}>
                <div className="ri"><Icon size={20} /></div>
                <div><h4>{r.title}</h4><p>View, filter & export to PDF / Excel</p></div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
